define.alias("shared/components/shared/trial-countdown", "calendar/components/shared/trial-countdown");